<template>
  <div>
    <div class="workspace-mobile-bar">
      <span>Schulplanung</span>
      <button :aria-expanded="String(open)" aria-controls="workspace-navigation"
        @click="open = !open">{{ open ? 'Schließen ✕' : 'Menü ☰' }}</button>
    </div>
    <button v-if="open" class="sidebar-backdrop" aria-label="Menü schließen"
      @click="open = false"></button>
    <aside id="workspace-navigation" class="workspace-sidebar" :class="{ 'is-open': open }"
      @keydown.esc="open = false">
      <router-link to="/dashboard" class="workspace-brand" @click.native="open = false">
        <img src="@/assets/images/LogoRSSBO_Header.svg" alt="Rudolf Steiner Schule Bochum"
          class="school-logo">
      </router-link>
      <button class="sidebar-collapse-toggle" type="button"
        :aria-label="collapsed ? 'Sidebar ausklappen' : 'Sidebar minimieren'"
        :title="collapsed ? 'Sidebar ausklappen' : 'Sidebar minimieren'"
        :aria-expanded="String(!collapsed)" aria-controls="workspace-navigation"
        @click="$store.commit('Layout/toggleSidebar')">
        <font-awesome-icon :icon="['fas', collapsed ? 'angle-double-right' : 'angle-double-left']"
          aria-hidden="true" />
      </button>
      <p class="navigation-label">Organisation</p>
      <nav aria-label="Hauptnavigation">
        <b-tooltip v-for="item in links" :key="item.path" :label="item.label"
          class="sidebar-tooltip" position="is-right" append-to-body
          :active="collapsed && !open" :triggers="['hover', 'focus']">
        <router-link :to="item.path"
          :aria-label="item.label"
          :aria-current="$route.path === item.path ? 'page' : null" @click.native="open = false">
          <span class="nav-symbol" aria-hidden="true">
            <font-awesome-icon v-if="item.icon" :icon="['fas', item.icon]" />
            <template v-else>{{ item.symbol }}</template>
          </span><span class="nav-label">{{ item.label }}</span>
        </router-link>
        </b-tooltip>
      </nav>
      <div class="sidebar-bottom">
        <button type="button" aria-label="Dark Mode" :aria-pressed="String(darkMode)"
          :title="darkMode ? 'Hellen Modus aktivieren' : 'Dark Mode aktivieren'"
          @click="$store.commit('Layout/toggleDarkMode')">
          <span class="nav-symbol" aria-hidden="true">
            <font-awesome-icon :icon="['fas', darkMode ? 'sun' : 'moon']" />
          </span><span class="nav-label">{{ darkMode ? 'Heller Modus' : 'Dark Mode' }}</span>
        </button>
        <b-tooltip label="Mein Profil" class="sidebar-tooltip" position="is-right"
          append-to-body :active="collapsed && !open" :triggers="['hover', 'focus']">
        <router-link to="/profile" aria-label="Mein Profil"
          @click.native="open = false">
          <span class="nav-symbol" aria-hidden="true">
            <font-awesome-icon :icon="['fas', 'id-badge']" />
          </span><span class="nav-label">Mein Profil</span>
        </router-link>
        </b-tooltip>
        <b-tooltip v-if="rights.acc" label="Account & Einstellungen" class="sidebar-tooltip"
          position="is-right" append-to-body :active="collapsed && !open"
          :triggers="['hover', 'focus']">
        <router-link to="/account"
          aria-label="Account & Einstellungen"
          @click.native="open = false">
          <span class="nav-symbol" aria-hidden="true">
            <font-awesome-icon :icon="['fas', 'cog']" />
          </span><span class="nav-label">Account &amp; Einstellungen</span>
        </router-link>
        </b-tooltip>
        <b-tooltip label="Abmelden" class="sidebar-tooltip" position="is-right"
          append-to-body :active="collapsed && !open" :triggers="['hover', 'focus']">
        <button @click="logout" aria-label="Abmelden">
          <span class="nav-symbol" aria-hidden="true">
            <font-awesome-icon :icon="['fas', 'sign-out-alt']" />
          </span><span class="nav-label">Abmelden</span>
        </button>
        </b-tooltip>
      </div>
    </aside>
  </div>
</template>

<script>
export default {
  data() {
    return {
      open: false,
      links: [
        { path: '/dashboard', label: 'Vertretungsplan', icon: 'table' },
        { path: '/teacher_management', label: 'Lehrkräfte', icon: 'user-injured' },
        { path: '/standby', label: 'Bereitschaften', icon: 'user-clock' },
        { path: '/agreements', label: 'Absprachen', icon: 'handshake' },
        // Font Awesome 5 names the bars-staggered icon "stream".
        { path: '/epochs', label: 'Epochen', icon: 'stream' },
        { path: '/supervision', label: 'Aufsichten', icon: 'eye' },
        // Font Awesome 5 names the calendar-days icon "calendar-alt".
        { path: '/teacher_week', label: 'Stundenpläne', icon: 'calendar-alt' },
        { path: '/help', label: 'Hilfe', icon: 'question-circle' },
      ],
    };
  },
  computed: {
    darkMode() { return this.$store.state.Layout.darkMode; },
    collapsed() { return this.$store.state.Layout.sidebarCollapsed; },
    rights() { return this.$store.getters['User/rights'] || {}; },
  },
  methods: {
    logout() {
      const client = this.$store.getters['User/client'];
      if (client.id === '6085b6010df67064d9332fb0') {
        window.location.href = 'https://trusted-employer.blg.de/';
      } else {
        this.$router.push({ path: `/${client.login_param || ''}` });
      }
      this.$store.commit('User/logout');
    },
  },
};
</script>
